import asyncComponent from '../lib/asyncComponent'

import { MapSigns } from 'styled-icons/fa-solid/MapSigns'
import { Tag } from 'styled-icons/fa-solid/Tag'
import { Tags } from 'styled-icons/fa-solid/Tags'
//import { Table } from 'styled-icons/fa-solid/Table'
import { UserCog } from 'styled-icons/fa-solid/UserCog'
//import { ListAlt } from 'styled-icons/fa-solid/ListAlt'
import { TachometerAlt } from 'styled-icons/fa-solid/TachometerAlt'
import { Map } from 'styled-icons/fa-regular/Map'
import { ChartLine } from 'styled-icons/fa-solid/ChartLine'
import { ChartBar } from 'styled-icons/fa-solid/ChartBar'

import { InfoCircle } from 'styled-icons/fa-solid/InfoCircle'
import { Sitemap } from 'styled-icons/fa-solid/Sitemap'
//import { FileAlt } from 'styled-icons/fa-regular/FileAlt'
import { Binoculars } from 'styled-icons/fa-solid/Binoculars'
import { ProjectDiagram } from 'styled-icons/fa-solid/ProjectDiagram'
//import { Grid } from 'styled-icons/feather/Grid'

const SiteManager = asyncComponent(() => import('./pages/SiteManager'))
const SitePage = asyncComponent(() => import('./pages/SitePage'))
const SiteView = asyncComponent(() => import('./pages/SiteView'))
const Production = asyncComponent(() => import('./pages/Production'))
const TrendChart = asyncComponent(() => import('./pages/TrendChart'))
const SiteConfigure = asyncComponent(() => import('./pages/SiteConfigure'))
//const DatabaseManager = asyncComponent(() => import('./pages/DatabaseManager'))
//const DatabaseViewer = asyncComponent(() => import('./pages/DatabaseViewer'))
//const Folder = asyncComponent(() => import('./pages/Folder'))
const RestTool = asyncComponent(() => import('./pages/RestTool'))

const Configurator = asyncComponent(() => import('./pages/Configurator'))
const ChannelPage = asyncComponent(() => import('./pages/ChannelPage'))
const EventPage = asyncComponent(() => import('./pages/EventPage'))
const UserPage = asyncComponent(() => import('./pages/UserPage'))

const DiagramEditor = asyncComponent(() => import('./pages/DiagramEditor'))
const Developer = asyncComponent(() => import('./api/Developer'))

const apps = {
  admin: [
    {name: 'Site',            alias: '/siteadmin',  icon: MapSigns,       component: SiteConfigure},
    {name: 'User',            alias: '/user',       icon: UserCog,        component: UserPage},
    {name: 'Channel',         alias: '/config',     icon: Tag,            component: Configurator},
//    {name: 'Database',        alias: '/dbmanager',  icon: Table,          component: DatabaseManager},
//    {name: 'DBViewer',        alias: '/dbviewer',   icon: ListAlt,        component: DatabaseViewer},
//    {name: 'System',      icon: 'fa fa-binoculars',    alias: '/framework',  component: Platform},
  ],
  appls: [
    {name: 'Dashboard',       alias: '/',           icon: TachometerAlt,  component: SiteManager},
    {name: 'Sites',           alias: '/sites',      icon: Map,            component: SitePage},
    {name: 'Site View',       alias: '/sites/:id',  icon: Sitemap,        component: SiteView,    menu: false},
    {name: 'Trend Chart',     alias: '/trend',      icon: ChartLine,      component: TrendChart},
    {name: 'Production',      alias: '/production/:id', icon: ChartBar,   component: Production},
    {name: 'Channel Viewer',  alias: '/channel',    icon: Tags,           component: ChannelPage},
    {name: 'Events',          alias: '/event',      icon: InfoCircle,     component: EventPage},
    {name: 'Diagram Editor',  alias: '/diagram',    icon: ProjectDiagram, component: DiagramEditor, menu: false},
    {name: 'Developer',       alias: '/api',        icon: Binoculars,     component: Developer,     menu: false},
  ],

  tools: [
/*
    {name: 'Documents',       alias: '/document',   icon: FileAlt,        component: Folder,         param: 'doc' },
*/
    {name: 'API Tool',        alias: '/apitool',    icon: Binoculars,     component: RestTool},
  ]

}

export default apps



// WEBPACK FOOTER //
// ./src/components/sm.js